import { useState, useEffect } from 'react';
import {
  Box, Button, TextField, Typography, Paper,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState('Admin');
  const [password, setPassword] = useState('123456');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true); // ⬅️ To avoid flickering

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      navigate('/');
    } else {
      setLoading(false);
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch('https://anydev.com-eg.net/api/Users/V1/Login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'CompanyID': '551001',
          'Language': 'ar',
        },
        body: JSON.stringify({
          userName: username,
          password: password,
          roleID: 5,
        }),
      });

      if (!response.ok) {
        throw new Error('Login failed');
      }

      const data = await response.json();
      const token = data?.data?.accessToken || data?.accessToken;

      if (!token) {
        throw new Error('Access token not found in response');
      }

      localStorage.setItem('accessToken', token);
      localStorage.setItem('username', username);
      localStorage.setItem('branch', data?.data?.branchArabicName || 'Unknown Branch');

      navigate('/');
    } catch (err) {
      console.error(err);
      setError('Login failed, please review your credentials.');
    }
  };

  if (loading) {
    return null; // Or a spinner if you prefer
  }

  return (
    <Box
      sx={{
        height: '100vh',
        background: 'linear-gradient(to right, #f2f4f7, #e0eafc)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        direction: 'ltr',
        fontFamily: 'Cairo, sans-serif',
      }}
    >
      <Paper
        elevation={4}
        sx={{
          p: 5,
          width: 380,
          maxWidth: '90%',
          borderRadius: 4,
          boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
          backgroundColor: '#ffffff',
        }}
      >
        <Typography variant="h5" mb={3} textAlign="center" fontWeight="bold" color="primary">
          Login
        </Typography>

        <form onSubmit={handleSubmit}>
          <TextField
            label="Username"
            fullWidth
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <TextField
            label="Password"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          {error && (
            <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
              {error}
            </Typography>
          )}

          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ mt: 3, py: 1.2, fontWeight: 'bold', fontSize: 16 }}
          >
            Login
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default Login;
